export const OFFSET_INCREEMENT = 5
export const SHORT_SELLER_RATING_COMMENT_LENGTH = 150
export const SELLER_DESCRIPTION_LENGTH = 500
export const SA_SELLER_NAME = 'SHOP APOTHEKE'
export const SELLER_TYPE_OPERATOR = 'OPERATOR'
export const SELLER_TYPE_SHOP = 'SHOP'
